<template>
  <div class="inspector-manage">
    <div class="inspector-header">
      <div class="title">巡考员管理</div>
      <div class="exam-info">{{ examName }}</div>
    </div>

    <div class="operation-bar">
      <div class="left-btns">
        <el-button type="primary" class="btn-add" @click="openAddDialog">批量添加</el-button>
      </div>
    </div>

    <div class="inspector-content">
      <!-- 有数据时显示表格 -->
      <el-table
        v-if="inspectorList.length > 0"
        :data="inspectorList"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="teacher_id"
          label="宏合账号"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="teacher_name"
          label="姓名"
          width="120"
        ></el-table-column>
        <el-table-column
          label="巡考科目"
          width="200"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.subject_list && scope.row.subject_list.length > 0">
              {{ scope.row.subject_list.join('、') }}
            </span>
            <span v-else class="no-data">暂未设置</span>
          </template>
        </el-table-column>
        <el-table-column
          label="巡考学校"
          width="200"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.school_list && scope.row.school_list.length > 0">
              {{ scope.row.school_list.join('、') }}
            </span>
            <span v-else class="no-data">暂未设置</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="openSettingDialog(scope.row)"
            >设置</el-button>
            <el-button
              size="mini"
              type="text"
              @click="deleteInspector(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 无数据时显示空状态 -->
      <div v-else class="empty-state">
        <div class="empty-text">还没有添加巡考员</div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-container">
      <span class="total-info">共 {{ total }} 条数据</span>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 添加巡考员弹窗 -->
    <el-dialog
      title="选择巡考员"
      :visible.sync="addDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      center
    >
      <div class="user-select-content">
        <div class="search-bar">
          <el-input
            v-model="userSearchKeyword"
            placeholder="请输入姓名或账号搜索"
            clearable
            @input="searchUsers"
            style="width: 300px; margin-bottom: 20px;"
          >
            <el-button slot="append" icon="el-icon-search" @click="searchUsers"></el-button>
          </el-input>
        </div>

        <el-table
          ref="userTable"
          :data="userList"
          style="width: 100%"
          border
          height="400px"
          v-loading="loadingUsers"
          @selection-change="handleUserSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="F_user_account" label="宏合账号" width="200"></el-table-column>
          <el-table-column prop="F_user_name" label="姓名" width="150"></el-table-column>
        </el-table>

        <div class="pagination-wrapper" style="margin-top: 20px; text-align: center;">
          <el-pagination
            background
            @current-change="handleUserPageChange"
            :current-page="userCurrentPage"
            :page-size="userPageSize"
            layout="prev, pager, next"
            :total="userTotal"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSelectedUsers" :loading="addingInspector">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量添加巡考员弹窗 -->
    <el-dialog
      title="批量添加巡考员"
      :visible.sync="batchDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      center
    >
      <div class="inspector-dialog-content">
        <p class="tip-text">请上传包含巡考员信息的文件（Excel格式）</p>
        <el-upload
          class="upload-container"
          action="#"
          :auto-upload="false"
          :on-change="handleFileChange"
          :limit="1"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件</div>
        </el-upload>
        <div class="template-download" style="margin-top: 10px;">
          <a href="https://static.hhyunyue.com/website/helper/template/巡考员导入模板.xlsx" target="_blank" download>
            下载巡考员导入模板
          </a>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="uploadBatchFile" :loading="uploading">上 传</el-button>
      </span>
    </el-dialog>

    <!-- 设置弹窗 -->
    <el-dialog
      title="巡考员设置"
      :visible.sync="settingDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      center
    >
      <div class="setting-dialog-content">
        <!-- 巡考科目选择 -->
        <div class="setting-section">
          <div class="section-title">巡考科目</div>
          <div class="subject-buttons">
            <div
              v-for="subject in subjectList"
              :key="subject.id || subject.subject_id"
              class="subject-button"
              :class="{ 'selected': selectedSubjects.includes(String(subject.id || subject.subject_id)) }"
              @click="toggleSubject(String(subject.id || subject.subject_id))"
            >
              {{ subject.name || subject.subject_name }}
            </div>
          </div>
        </div>

        <!-- 巡考学校选择 -->
        <div class="setting-section">
          <div class="section-title">巡考学校</div>
          <div class="school-search">
            <el-input
              v-model="schoolSearch"
              placeholder="请输入学校名称"
              clearable
              @clear="clearSchoolSearch"
              @input="searchSchools"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchSchools"></el-button>
            </el-input>
          </div>
          <div class="school-wrapper">
            <div class="all-option" @click="toggleAllSchools">
              <span :class="{ 'selected': isAllSchoolsSelected }">全选</span>
            </div>
            <div class="school-buttons">
              <div
                v-for="school in filteredSchools"
                :key="school.id || school.school_id"
                class="school-button"
                :class="{ 'selected': selectedSchools.includes(String(school.id || school.school_id)) }"
                @click="toggleSchool(String(school.id || school.school_id))"
              >
                {{ school.name || school.school_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSettings" :loading="savingSettings">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { MessageBox } from 'element-ui';
import domain from '@/scripts/domain';

export default {
  name: 'InspectorManage',
  data() {
    return {
      examId: '',
      examName: '',
      inspectorList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      addDialogVisible: false,
      batchDialogVisible: false,
      inspectorForm: {
        account: '',
        name: ''
      },
      addingInspector: false,
      fileList: [],
      uploading: false,
      settingDialogVisible: false,
      subjectList: [],
      selectedSubjects: [],
      schoolSearch: '',
      filteredSchools: [],
      selectedSchools: [],
      savingSettings: false,
      currentInspector: null,
      schoolList: [],
      userSearchKeyword: '',
      userList: [],
      loadingUsers: false,
      userCurrentPage: 1,
      userPageSize: 10,
      userTotal: 0,
      searchTimer: null,
      selectedUserList: [],
    }
  },
  computed: {
    // 计算是否全部学校已选中
    isAllSchoolsSelected() {
      if (this.schoolList.length === 0) return false;

      // 检查是否所有学校ID都在selectedSchools中
      return this.schoolList.every(school => this.selectedSchools.includes(String(school.id || school.school_id)));
    }
  },
  created() {
    this.examId = this.$route.query.examId;
    this.examName = this.$route.query.examName;
    this.getInspectorList();
  },
  methods: {
    // 获取巡考员列表
    async getInspectorList() {
      try {
        // 确保考试ID存在
        if (!this.examId) {
          console.error('考试ID不存在');
          this.$message.error('获取巡考员列表失败: 考试ID不存在');
          return;
        }

        console.log('正在获取巡考员列表，考试ID:', this.examId);

        const response = await Vue.http({
          url: `${this.$serve.url}/v1/joint/xunkao/list`,
          method: 'get',
          params: {
            exam_id: this.examId
          }
        });

        console.log('巡考员列表响应:', response);

        if (response.status === 200 && response.body) {
          // 优先处理{status_code: 200, message: "ok", data: {...}}格式
          if (response.body.status_code === 200 && response.body.message === 'ok' && response.body.data) {
            this.inspectorList = response.body.data.list || response.body.data || [];
            this.total = response.body.data.total || (Array.isArray(response.body.data) ? response.body.data.length : 0);
          }
          // 检查其他响应格式
          else if (response.body.code === 0 && response.body.data) {
            // 标准格式
            this.inspectorList = response.body.data.list || [];
            this.total = response.body.data.total || 0;
          } else if (Array.isArray(response.body)) {
            // 直接返回数组
            this.inspectorList = response.body;
            this.total = response.body.length;
          } else if (response.body.list) {
            // 另一种可能的格式
            this.inspectorList = response.body.list;
            this.total = response.body.total || response.body.list.length;
          } else {
            // 未知格式
            this.inspectorList = [];
            this.total = 0;
            console.error('未知的响应格式:', response.body);
          }
        } else {
          // this.$message.error('获取巡考员列表失败');
          this.inspectorList = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('获取巡考员列表失败', error);
        this.$message.error('获取巡考员列表失败，请稍后重试');
        this.inspectorList = [];
        this.total = 0;
      }
    },

    // 分页
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getInspectorList();
    },

    // 打开添加弹窗
    openAddDialog() {
      this.addDialogVisible = true;
      this.userSearchKeyword = '';
      this.userCurrentPage = 1;
      this.getUserList();
    },

    // 打开批量添加弹窗
    openBatchDialog() {
      this.fileList = [];
      this.batchDialogVisible = true;
    },

    // 获取用户列表
    async getUserList() {
      try {
        this.loadingUsers = true;

        // 获取本地缓存的用户ID
        const adminId = localStorage.getItem('examination_user_id');
        if (!adminId) {
          this.$message.error('获取用户信息失败，请重新登录');
          return;
        }

        // 使用domain.js中的配置
        // 赵可豪改的bug
        const response = await Vue.http({
          url: `${domain['accurate-admin-web']['single-api-domain']}/inspector/sys_user`,
          method: 'get',
          params: {
            F_role_name: '巡考员',
            F_page: this.userCurrentPage,
            F_limit: this.userPageSize,
            F_admin_id: adminId,
            F_keyword: this.userSearchKeyword || '' // 搜索关键词
          }
        });

        console.log('用户列表响应:', response);

        if (response.status === 200 && response.body) {
          // 处理accurate-admin-web接口特有的响应格式
          if (response.body.F_responseNo === 10000) {
            this.userList = response.body.F_user_list || [];
            this.userTotal = response.body.F_page_info?.F_total || 0;
            console.log('成功解析用户数据 - 用户数量:', this.userList.length, '总数:', this.userTotal);
          }
          // 处理其他可能的响应格式
          else if (response.body.code === 0 || response.body.status_code === 200) {
            this.userList = response.body.data?.list || response.body.data || [];
            this.userTotal = response.body.data?.total || response.body.total || 0;
          } else {
            this.$message.error(response.body.F_responseMsg || response.body.message || '获取用户列表失败');
            this.userList = [];
            this.userTotal = 0;
          }
        } else {
          this.$message.error('获取用户列表失败');
          this.userList = [];
          this.userTotal = 0;
        }
      } catch (error) {
        console.error('获取用户列表失败', error);
        this.$message.error('获取用户列表失败，请稍后重试');
        this.userList = [];
        this.userTotal = 0;
      } finally {
        this.loadingUsers = false;
      }
    },

    // 处理用户分页
    handleUserPageChange(page) {
      this.userCurrentPage = page;
      this.getUserList();
    },

    // 处理用户选择变化
    handleUserSelectionChange(selection) {
      this.selectedUserList = selection;
    },

    // 添加选中的用户
    async addSelectedUsers() {
      if (this.selectedUserList.length === 0) {
        this.$message.warning('请选择要添加的用户');
        return;
      }

      try {
        this.addingInspector = true;

        // 批量添加选中的用户
        for (const user of this.selectedUserList) {
          const formData = new FormData();
          formData.append('exam_id', this.examId);
          formData.append('teacher_id', user.F_user_account);
          formData.append('teacher_name', user.F_user_name);

          const response = await Vue.http({
            url: `${this.$serve.url}/v1/joint/xunkao/add`,
            method: 'post',
            body: formData
          });

          if (!(response.status === 200 && (
            (response.body && response.body.code === 0)
              || (response.body && response.body.status_code === 200)
              || (response.body && response.body.message === 'ok')
          ))) {
            console.warn(`添加用户 ${user.F_user_name} 失败:`, response);
          }
        }

        this.$message.success(`成功添加 ${this.selectedUserList.length} 个巡考员`);
        this.addDialogVisible = false;
        this.selectedUserList = [];
        this.getInspectorList();
      } catch (error) {
        console.error('批量添加巡考员失败', error);
        this.$message.error('批量添加巡考员失败，请稍后重试');
      } finally {
        this.addingInspector = false;
      }
    },

    // 文件选择
    handleFileChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },

    // 删除巡考员
    async deleteInspector(row) {
      try {
        await MessageBox.confirm('确定要删除该巡考员吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 创建FormData对象
        const formData = new FormData();
        formData.append('exam_id', this.examId);
        formData.append('teacher_id', row.teacher_id);

        // 调用删除API，使用FormData格式
        const response = await Vue.http({
          url: `${this.$serve.url}/v1/joint/xunkao/delete`,
          method: 'post',
          body: formData
        });

        // 增加对{status_code: 200, message: "ok"}格式的支持
        if (response.status === 200 && (
          (response.body && response.body.code === 0)
            || (response.body && response.body.status_code === 200)
            || (response.body && response.body.message === 'ok')
        )) {
          this.$message.success('删除成功');
          this.getInspectorList();
        } else {
          const errorMsg = (response.body && response.body.msg)
                          || (response.body && response.body.message && response.body.message !== 'ok' ? response.body.message : '删除失败，请稍后重试');
          this.$message.error(errorMsg);
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败', error);
          this.$message.error('删除失败，请稍后重试');
        }
      }
    },

    // 上传批量文件
    async uploadBatchFile() {
      if (this.fileList.length === 0) {
        this.$message.warning('请先选择文件');
        return;
      }

      const file = this.fileList[0].raw;
      // 检查文件类型
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (!['xlsx', 'xls'].includes(fileExtension)) {
        this.$message.error('只能上传Excel文件（xlsx/xls格式）');
        return;
      }

      try {
        this.uploading = true;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('exam_id', this.examId);

        // 调用上传API
        const response = await Vue.http({
          url: `${this.$serve.url}/v1/joint/xunkao/import`,
          method: 'post',
          body: formData
        });

        // 增加对{status_code: 200, message: "ok"}格式的支持
        if (response.status === 200 && (
          (response.body && response.body.code === 0)
            || (response.body && response.body.status_code === 200)
            || (response.body && response.body.message === 'ok')
        )) {
          this.$message.success('批量添加巡考员成功');
          this.batchDialogVisible = false;
          this.getInspectorList();
        } else {
          const errorMsg = (response.body && response.body.msg)
                          || (response.body && response.body.message && response.body.message !== 'ok' ? response.body.message : '上传失败，请稍后重试');
          this.$message.error(errorMsg);
        }
      } catch (error) {
        console.error('批量添加巡考员失败', error);
        this.$message.error('上传失败，请稍后重试');
      } finally {
        this.uploading = false;
      }
    },

    // 打开设置弹窗
    async openSettingDialog(row) {
      this.currentInspector = row;
      this.settingDialogVisible = true;

      // 初始化选中状态
      this.selectedSubjects = [];
      this.selectedSchools = [];

      // 先加载科目和学校列表
      await Promise.all([
        this.getSubjectList(),
        this.getSchoolList()
      ]);

      // 根据当前巡考员的设置初始化选中状态
      this.initializeInspectorSettings(row);
    },

    // 根据巡考员的当前设置初始化选中状态
    initializeInspectorSettings(inspector) {
      console.log('正在初始化巡考员设置:', inspector);
      console.log('可用科目列表:', this.subjectList);
      console.log('可用学校列表:', this.schoolList);

      // 根据科目名称找到对应的ID
      if (inspector.subject_list && inspector.subject_list.length > 0) {
        this.selectedSubjects = [];
        inspector.subject_list.forEach(subjectName => {
          console.log('查找科目:', subjectName);
          const subject = this.subjectList.find(s => s.name === subjectName || s.subject_name === subjectName);
          if (subject) {
            const subjectId = String(subject.id || subject.subject_id);
            this.selectedSubjects.push(subjectId);
            console.log('找到匹配科目:', subject, '添加ID:', subjectId);
          } else {
            console.warn('未找到匹配的科目:', subjectName);
          }
        });
      }

      // 根据学校名称找到对应的ID
      if (inspector.school_list && inspector.school_list.length > 0) {
        this.selectedSchools = [];
        inspector.school_list.forEach(schoolName => {
          console.log('查找学校:', schoolName);
          const school = this.schoolList.find(s => s.name === schoolName || s.school_name === schoolName || s.F_name === schoolName);
          if (school) {
            const schoolId = String(school.id || school.school_id || school.F_id);
            this.selectedSchools.push(schoolId);
            console.log('找到匹配学校:', school, '添加ID:', schoolId);
          } else {
            console.warn('未找到匹配的学校:', schoolName);
          }
        });
      }

      console.log('最终选中科目ID:', this.selectedSubjects);
      console.log('最终选中学校ID:', this.selectedSchools);
    },

    // 获取考试科目列表
    async getSubjectList() {
      try {
        // 使用/v1/exam/subjects接口获取考试所有科目
        const response = await Vue.http({
          url: `${this.$serve.url}/v1/exam/subjects`,
          method: 'get',
          params: {
            exam_id: this.examId
          }
        });

        if (response.status === 200 && response.body) {
          let subjectData = [];

          // 处理{status_code: 200, message: "ok", data: [...]}格式
          if (response.body.status_code === 200 && response.body.message === 'ok' && response.body.data) {
            subjectData = response.body.data;
          }
          // 处理其他可能的返回格式
          else if (response.body.code === 0 && response.body.data) {
            subjectData = response.body.data;
          } else if (Array.isArray(response.body)) {
            subjectData = response.body;
          } else if (response.body.subjects) {
            subjectData = response.body.subjects;
          } else {
            subjectData = [];
            console.error('未知的科目列表响应格式:', response.body);
          }

          // 标准化科目数据格式
          this.subjectList = subjectData.map(subject => ({
            id: subject.id || subject.subject_id,
            name: subject.name || subject.subject_name
          }));

          console.log('成功获取考试科目列表:', this.subjectList);
        } else {
          this.$message.error('获取科目列表失败');
          this.subjectList = [];
        }
      } catch (error) {
        console.error('获取科目列表失败', error);
        this.$message.error('获取科目列表失败，请稍后重试');
        this.subjectList = [];
      }
    },

    // 获取学校列表
    async getSchoolList() {
      try {
        // 获取考试参与的所有学校信息
        const response = await Vue.http({
          url: `${this.$serve.url}/v1/joint/exam/schools`,
          method: 'get',
          params: {
            exam_id: this.examId
          }
        });

        if (response.status === 200 && response.body) {
          let schoolData = [];

          // 优先处理{status_code: 200, message: "ok", data: [...]}格式
          if (response.body.status_code === 200 && response.body.message === 'ok' && response.body.data) {
            schoolData = response.body.data;
          }
          // 处理其他可能的返回格式
          else if (response.body.code === 0 && response.body.data) {
            schoolData = response.body.data;
          } else if (Array.isArray(response.body)) {
            schoolData = response.body;
          } else if (response.body.schools) {
            schoolData = response.body.schools;
          } else if (response.body.joint_schools) {
            schoolData = response.body.joint_schools;
          } else if (response.body.F_data) {
            schoolData = response.body.F_data;
          } else {
            // 尝试从getSingleExamS接口获取联考学校信息
            try {
              const examResponse = await this.$serve.getSingleExamS(this.examId);
              if (examResponse.status === 200 && examResponse.body && examResponse.body.joint_schools) {
                schoolData = examResponse.body.joint_schools;
              }
            } catch (error) {
              console.error('获取考试联考学校信息失败', error);
            }
          }

          // 标准化学校数据格式
          this.schoolList = schoolData.map(school => ({
            id: school.id || school.school_id || school.F_id,
            name: school.name || school.school_name || school.F_name
          }));

          this.filteredSchools = [...this.schoolList];
          console.log('成功获取考试学校列表:', this.schoolList);
        } else {
          this.$message.error('获取学校列表失败');
          this.schoolList = [];
          this.filteredSchools = [];
        }
      } catch (error) {
        console.error('获取学校列表失败', error);
        this.$message.error('获取学校列表失败，请稍后重试');
        this.schoolList = [];
        this.filteredSchools = [];
      }
    },

    // 切换科目选择
    toggleSubject(subjectId) {
      if (this.selectedSubjects.includes(subjectId)) {
        this.selectedSubjects = this.selectedSubjects.filter(id => id !== subjectId);
      } else {
        this.selectedSubjects.push(subjectId);
      }
    },

    // 搜索学校
    searchSchools() {
      if (!this.schoolSearch.trim()) {
        this.filteredSchools = [...this.schoolList];
        return;
      }

      const searchTerm = this.schoolSearch.trim().toLowerCase();
      this.filteredSchools = this.schoolList.filter(school => school.name.toLowerCase().includes(searchTerm));
    },

    // 切换学校选择
    toggleSchool(schoolId) {
      if (this.selectedSchools.includes(schoolId)) {
        this.selectedSchools = this.selectedSchools.filter(id => id !== schoolId);
      } else {
        this.selectedSchools.push(schoolId);
      }
    },

    // 清除学校搜索
    clearSchoolSearch() {
      this.schoolSearch = '';
      this.filteredSchools = [...this.schoolList];
    },

    // 保存设置
    async saveSettings() {
      if (!this.currentInspector) {
        this.$message.error('未选择巡考员');
        return;
      }

      try {
        this.savingSettings = true;

        // 创建FormData对象
        const formData = new FormData();
        formData.append('exam_id', this.examId);
        formData.append('teacher_id', this.currentInspector.teacher_id);

        // 将选中的科目ID转换为逗号分隔的字符串
        if (this.selectedSubjects.length > 0) {
          formData.append('subjects', this.selectedSubjects.join(','));
        } else {
          formData.append('subjects', '');
        }

        // 将选中的学校ID转换为逗号分隔的字符串
        if (this.selectedSchools.length > 0) {
          formData.append('schools', this.selectedSchools.join(','));
        } else {
          formData.append('schools', '');
        }

        // 调用保存设置的API
        const response = await Vue.http({
          url: `${this.$serve.url}/v1/joint/xunkao/update`,
          method: 'post',
          body: formData
        });

        if (response.status === 200) {
          // 检查不同的响应格式
          if (
            (response.body && response.body.code === 0)
            || (response.body && response.body.status === 'success')
            || (response.body && response.body.F_responseNo === 10000)
            || (response.body && response.body.status_code === 200)
            || (response.body && response.body.message === 'ok')
          ) {
            this.$message.success('巡考员设置保存成功');
            this.settingDialogVisible = false;
            this.getInspectorList(); // 刷新列表
          } else {
            const errorMsg = (response.body && response.body.msg)
              || (response.body && response.body.F_responseMsg)
              || (response.body && response.body.message && response.body.message !== 'ok' ? response.body.message : '保存设置失败，请稍后重试');
            this.$message.error(errorMsg);
          }
        } else {
          this.$message.error('保存设置失败，请稍后重试');
        }
      } catch (error) {
        console.error('保存巡考员设置失败', error);
        this.$message.error('保存设置失败，请稍后重试');
      } finally {
        this.savingSettings = false;
      }
    },

    // 切换所有学校选择
    toggleAllSchools() {
      if (this.isAllSchoolsSelected) {
        // 如果全部已选中，则清空选择
        this.selectedSchools = [];
      } else {
        // 否则选中所有学校
        this.selectedSchools = this.schoolList.map(school => String(school.id || school.school_id));
      }
    },

    // 搜索用户
    async searchUsers() {
      // 使用防抖，避免频繁请求
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.userCurrentPage = 1;
        this.getUserList();
      }, 500);
    },
  }
}
</script>

<style lang="less" scoped>
.inspector-manage {
  padding: 20px;
  background-color: #f7f8fa;
  min-height: calc(100vh - 100px);
}

.inspector-header {
  margin-bottom: 20px;

  .title {
    font-size: 22px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
  }

  .exam-info {
    font-size: 14px;
    color: #666;
  }
}

.operation-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .left-btns {
    display: flex;
    align-items: center;

    .btn-add {
      background-color: #40DBBC;
      border-color: #40DBBC;
      margin-right: 12px;
    }

    .btn-batch-add {
      color: #40DBBC;
      border-color: #40DBBC;
      margin-right: 20px;
    }

    .help-link {
      color: #40DBBC;
    }
  }
}

.inspector-content {
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
  min-height: 400px;

  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;

    .empty-text {
      font-size: 16px;
      color: #999;
    }
  }

  .no-data {
    color: #999;
    font-style: italic;
    font-size: 13px;
  }
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  .total-info {
    font-size: 14px;
    color: #666;
  }
}

.inspector-dialog-content {
  padding: 20px;

  .input-row {
    margin-bottom: 20px;

    .label {
      margin-bottom: 8px;
      font-size: 14px;
      color: #606266;
    }
  }

  .tip-text {
    margin-bottom: 20px;
    color: #666;
    font-size: 14px;
  }

  .upload-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .template-download a {
    color: #40DBBC;
    text-decoration: underline;
    font-size: 14px;
  }
}

.setting-dialog-content {
  padding: 20px;

  .setting-section {
    margin-bottom: 30px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 15px;
      padding-left: 5px;
      border-left: 3px solid #40DBBC;
    }
  }

  .subject-buttons {
    display: flex;
    flex-wrap: wrap;

    .subject-button {
      padding: 8px 16px;
      margin: 5px;
      background-color: #f5f5f5;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: #eaf8f6;
        border-color: #40DBBC;
      }

      &.selected {
        background-color: #40DBBC;
        color: #fff;
        border-color: #40DBBC;
      }
    }
  }

  .school-search {
    margin-bottom: 15px;

    .el-input {
      width: 300px;
    }
  }

  .school-wrapper {
    display: flex;
    align-items: center;

    .all-option {
      padding: 8px 16px;
      margin-right: 10px;
      background-color: #f5f5f5;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: #eaf8f6;
        border-color: #40DBBC;
      }

      &.selected, span.selected {
        color: #40DBBC;
        font-weight: bold;
      }
    }
  }

  .school-buttons {
    display: flex;
    flex-wrap: wrap;
    max-height: 300px;
    overflow-y: auto;

    .school-button {
      padding: 8px 16px;
      margin: 5px;
      background-color: #f5f5f5;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: #eaf8f6;
        border-color: #40DBBC;
      }

      &.selected {
        background-color: #40DBBC;
        color: #fff;
        border-color: #40DBBC;
      }
    }
  }
}

.user-select-content {
  padding: 20px;

  .search-bar {
    margin-bottom: 20px;
  }

  .pagination-wrapper {
    text-align: center;
  }
}
</style>
